import { useTranslation } from 'react-i18next';

import { colors } from 'components/styles/variables';
import { useMakeModelFilter } from 'lib/hooks/useSrpFilters';

export interface ResultCountProps {
  totalCount: number;
  make?: string;
  model?: string;
  isLoading: boolean;
}

const ResultCount = ({ totalCount, make, model, isLoading }: ResultCountProps): JSX.Element => {
  const { value: filterValue } = useMakeModelFilter();
  const { t } = useTranslation();

  const makeModelMessage = ((): string => {
    if (isLoading || (!make && !model && !filterValue.make && !filterValue.model)) {
      return t('srp.resultsList.vehiclesFound');
    }

    if (filterValue.make || filterValue.model) {
      return t('srp.resultsList.results', {
        makeModel: `${filterValue.make || ''} ${filterValue.model || ''}`,
      });
    }

    return t('srp.resultsList.results', {
      makeModel: `${make || ''} ${model || ''}`,
    });
  })();

  return (
    <>
      <div className="total-count-container">
        <span>
          <h2 className="total-count-subtitle">
            <span className="total-count">
              {isLoading ? '-----' : totalCount?.toLocaleString()}
            </span>
            &nbsp;
            <span className="make-model">{makeModelMessage}</span>
          </h2>
        </span>
      </div>
      <style jsx>
        {`
          .total-count-subtitle {
            margin: auto;
          }
          .make-model {
            font-size: 14px;
            font-weight: normal;
          }
          .total-count {
            margin-right: 6px;
            display: inline;
            font-size: 22px;
            line-height: 32px;
            letter-spacing: 0.2px;
            color: ${colors.BLACK};
          }

          .total-count-container {
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            letter-spacing: 0.2px;
            color: ${colors.BLACK};
            min-width: fit-content;
            margin-bottom: 16px;
          }

          .container-mobile {
            margin-top: 12px;
            margin-left: 12px;
          }
        `}
      </style>
    </>
  );
};

export default ResultCount;
